class HeroBannerComponent extends HTMLElement {
  connectedCallback() {
    const swiper = this.querySelector('.swiper');
    if (!swiper) return;

    const loop = this.dataset.loop === 'true';
    const autoplay = this.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 4000;

    const config = {
      loop,
      speed: 600,
      pagination: {
        el: swiper.querySelector('.swiper-pagination'),
        clickable: true,
      },
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
    };

    if (autoplay) {
      config.autoplay = {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    new Swiper(swiper, config);
  }
}

customElements.define('hero-banner-component', HeroBannerComponent);